/* Core & libraries */
import React, { useState, useEffect } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useLocation, useNavigate } from "react-router-dom";

/* Helpers, constants, custom methods, internal libraries */
import { PROMOTIONS_PARTNER_ROUTE } from "../../constants/routes";

/* Components */
import PartnerPromotionsTab from "./partnerPromotionsTab";

/* Styles */
import styles from "./styles";

const PromotionsTabbedNav = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const location = useLocation();
  const navigate = useNavigate();

  const TAB_PARTNER = "partner";

  const getDefaultTab = () => {
    if (location.pathname.includes(PROMOTIONS_PARTNER_ROUTE)) return TAB_PARTNER;
  };

  const [activeTab, setActiveTab] = useState(() => getDefaultTab() || TAB_PARTNER);

  useEffect(() => {
    const tab = getDefaultTab();
    if (!tab) navigate(PROMOTIONS_PARTNER_ROUTE, { replace: true });
    else setActiveTab(tab);
  }, [location.pathname]);

  const handleTabChange = (nextTab) => {
    switch (nextTab) {
      case TAB_PARTNER:
        navigate(PROMOTIONS_PARTNER_ROUTE);
        break;
    }
  };

  return (
    <div className={classes.promotionsTabbedNav}>
      <Tabs
        onSelect={(nextTab) => handleTabChange(nextTab)}
        activeKey={activeTab}
        id="promotions-page-tabs"
        className={classes.tabs}
      >
        <Tab
          eventKey={TAB_PARTNER}
          title={<FormattedMessage id="promotions.partnerPromotions.tabTitle" />}
        >
          {activeTab === TAB_PARTNER && <PartnerPromotionsTab />}
        </Tab>
      </Tabs>
    </div>
  );
};

export default PromotionsTabbedNav;
